/* @jsx h */
import { defineComponent, h } from "vue";
import { GroupRevenueDashboard } from "./components/GroupRevenueDashboard";

export const GroupRevenuePage = defineComponent({
  name: "GroupRevenuePage",
  setup() {
    return () => (
      <div class="flex min-h-0 w-full flex-1 flex-col">
        <GroupRevenueDashboard />
      </div>
    );
  },
});
